import { render } from "./PrivacyPolicyAgreement.vue?vue&type=template&id=15d5a2de&scoped=true"
import script from "./PrivacyPolicyAgreement.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyAgreement.vue?vue&type=script&lang=js"

import "./PrivacyPolicyAgreement.vue?vue&type=style&index=0&id=15d5a2de&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1189531127/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d5a2de"]])

export default __exports__